import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useState } from "react"


function Header({ siteTitle }) {
  const [isExpanded, toggleExpansion] = useState(false)

  return (
    <nav className="flex flex-wrap items-center justify-between p-6 bg-gradient-to-b from-red-600 to-red-700">
      <div className="flex items-center flex-shrink-0 mr-6 ">
        <Link to={`/`}>
          <span className="text-white text-xl font-bold tracking-tight">
            {siteTitle}
          </span>
        </Link>
      </div>
      <div className="block lg:hidden">
        <button
          onClick={() => toggleExpansion(!isExpanded)}
          className="flex items-center px-3 py-2 text-white border border-white rounded hover:text-white hover:border-white"
        >
          <svg
            className="w-3 h-3 fill-current"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>
      </div>
      <div
        className={`${
          isExpanded ? `block` : `hidden`
        } w-full block flex-grow lg:flex lg:items-center lg:w-auto`}
      >
        <div className="flex flex-col items-center lg:flex-row text-sm lg:flex-grow lg:justify-end">
          <Link
            to={`/`}
            href="#responsive-header"
            className="block mt-4 mr-4 text-white lg:inline-block lg:mt-0 hover:text-white"
          >
            Home
          </Link>
          <Link
            to={`/products`}
            className="block mt-4 mr-4 text-white lg:inline-block lg:mt-0 hover:text-white"
          >
            Productos
          </Link>
          <Link
            to={`/about-us`}
            className="block mt-4 mr-4 text-white lg:inline-block lg:mt-0 hover:text-white"
          >
            Quienes Somos
          </Link>
          <Link
            to={`/contact`}
            className="block mt-4 mr-4 text-white lg:inline-block lg:mt-0 hover:text-white"
          >
            Contacto
          </Link>

          <a
            href="https://www.solicitudgriguol.com.ar/"
            className="btn btn-secondary mt-4 lg:mt-0"
          >
            <span className="icon-shield mr-2" />
            Acceso APP
          </a>
        </div>
      </div>
    </nav>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
